// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';
import { useCurrentRoute } from 'react-navi';
import { Typography } from '@kintent/glide';

import * as Styles from './LeftPanel.styles';
import { useDocumentSections } from '../../../../../lib/state';

function MenuItem({ to, ...delegated }) {
  return (
    <Styles.MenuItem
      activeClassName="active"
      href={{ query: { section: to } }}
      level="8"
      {...delegated}
    />
  );
}

export function LeftPanel() {
  const {
    url: { query },
  } = useCurrentRoute();
  const [sections] = useDocumentSections();

  return (
    <Styles.LeftPanel data-testid="document-section-left-panel">
      <Typography
        level="7"
        strength="60%"
      >
        Section
      </Typography>

      <ul>
        <li>
          <MenuItem
            active={!query.section}
            href="/documents"
          >
            All
          </MenuItem>
        </li>
        {sections.map((section) => {
          return (
            <li key={section.id}>
              <MenuItem
                active={section.name === query.section}
                to={section.name}
              >
                {section.name}
              </MenuItem>
            </li>
          );
        })}
      </ul>
    </Styles.LeftPanel>
  );
}
